import React from 'react';
import { GatsbyImage, getImage, IGatsbyImageData } from 'gatsby-plugin-image';
import ShortUnderline from 'assets/icons/shortUnderline.svg';
import { createArticleUrl } from 'helpers/utils';
import { SmartLink } from 'components/smart-link';
import * as styles from './latest-articles.module.scss';

export type LatestArticleType = {
  id: string;
  title: string;
  slug: string;
  description: string;
  primaryImage: {
    localFile: {
      childImageSharp: {
        gatsbyImageData: IGatsbyImageData;
      }
    }
  }
  category: {
    slug: string
  }
  subcategory: {
    slug: string
  }
};

type LatestArticlesProps = {
  latest: LatestArticleType[]
};

const LatestArticles = (props: LatestArticlesProps) => {
  const { latest } = props;

  return (
    <div className={styles.latestContainer}>
      <div className={styles.titleContainer}>
        <h1 className={styles.title}>Latest</h1>
        <ShortUnderline className={styles.underline} />
      </div>
      <div className={styles.listContainer}>
        {latest.map((article) => {
          const image = article.primaryImage ? getImage(article.primaryImage.localFile) : null;

          return (
            <SmartLink
              key={article.id}
              to={createArticleUrl(article.category.slug, article.subcategory.slug, article.slug)}
              className={styles.itemContainer}
            >
              {image && (
                <GatsbyImage
                  image={image}
                  alt={`${article.title} article description `}
                  className={styles.itemImg}
                  objectFit="cover"
                />
              )}
              <div className={styles.itemTitle}>{article.title}</div>
              <div className={styles.itemDescription}>{article.description}</div>
            </SmartLink>
          );
        })}
      </div>
    </div>
  );
};

export default LatestArticles;
